import "core-js/modules/es.regexp.exec";
import "core-js/modules/es.string.replace";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import activationCode from "./activationCode.vue";
import competitionStudent from "./competitionStudent.vue";
import predeterStudent from "./predeterStudent.vue";
import scoreList from './scoreList.vue';
import winnerList from "./winnerList.vue";
export default {
  name: "divisionAllController",
  components: {
    activationCode: activationCode,
    competitionStudent: competitionStudent,
    predeterStudent: predeterStudent,
    scoreList: scoreList,
    winnerList: winnerList
  },
  mixins: [],
  data: function data() {
    return {
      activeIndex: 'activationCode',
      eventId: '',
      end_time: '',
      isShowTab: false,
      eventStatus: ''
    };
  },
  created: function created() {
    this.eventId = this.$route.query.eventId || sessionStorage.getItem('eventId');
    this.eventStatus = this.$route.query.eventStatus || sessionStorage.getItem('eventStatus'); // this.end_time = sessionStorage.getItem('endTime');
    // this.isShowTab = this.isBeforeEndTime(this.end_time)

    this.activeIndex = 'activationCode';
  },
  activated: function activated() {},
  methods: {
    handover: function handover(index) {
      this.activeIndex = index;
    },
    isBeforeEndTime: function isBeforeEndTime(endTime) {
      if (!endTime) return false;
      var now = new Date();
      var end = new Date(endTime.replace(/-/g, '/'));
      return now < end;
    }
  }
};